import React from "react";
import SearchableSelect from "../../../modules/SearchableSelect";
import { Checkbox, MultiSelect } from "@familyzone/component-library";
import "../../../../css/PerformanceMetrics.css";

interface OnChange {
  value: string;
}

interface Item {
  value: string;
  text?: string | undefined;
}

interface DiagnosticsMetricsAdvancedProps {
  dynamic_metric: string;
  handle_MetricChange: (event: OnChange) => void;
  handle_SelectAll: () => void;
  handle_SetSelectedDevices: (dev: Item[]) => void;
  sphireos_version: number;
  is_parent: boolean;
  device_ids: Item[];
  selected_device_ids: Item[];
}

const DiagnosticsMetricsAdvancedSelector: React.FC<DiagnosticsMetricsAdvancedProps> = ({
  dynamic_metric = "",
  handle_MetricChange = () => "",
  handle_SelectAll = () => "",
  handle_SetSelectedDevices = () => "",
  sphireos_version = 269,
  is_parent = false,
  device_ids = [],
  selected_device_ids = [],
}) => {
  const SPHIREOS_PERFORMANCE_METRICS = [
    ["appliance_gateway.connections", "Appliance Gateway Connections Total"],
    ["auth.radius.accounting_packets.persec", "RADIUS Accounting Packet Rate (packets/s)"],
    ["configuration.version", "Cloud Configuration Version"],
    ["firewall.arp.size", "ARP Table Size"],
    ["firewall.conntracker.container.size", "Connection Tracker Size"],
    ["firewall.conntracker.gbremovedconnections", "Connection Tracker Cleanup Removed Connections"],
    ["firewall.conntracker.icmp.size", "ICMP Connections Total"],
    ["firewall.conntracker.tcp.size", "TCP Connections Total"],
    ["firewall.conntracker.total.connections", "All Connections Total"],
    ["firewall.conntracker.udp.size", "UDP Connections Total"],
    ["firewall.fzagent.bypass.bytes.persec", "Agent Bypassed Throughput (B/s)"],
    ["firewall.fzagent.bypass.devices.size", "Agent Bypassed Devices Total"],
    ["firewall.fzagent.bypass.packets.persec", "Agent Bypassed Throughput (packets/s)"],
    ["firewall.transfer.persec", "Appliance Throughput (bps)"],
    ["firewall.transfer.packets.persec", "Appliance Throughput (packets/s)"],
    ["nfqueue.filter.average_handling_time.us", "Average Packet Handling Time (μs)"],
    ["sessiondb.size", "User Session Database Size"],
    ["sphirewall.version", "SphireOS Version"],
    ["sysctl.net.netfilter.nf_conntrack_count", "Netfilter Connections Total"],
    ["system.cpu_usage", "CPU Utilization"],
    ["system.fs.configuration.available", "Configuration Partition Available Space (B)"],
    ["system.fs.configuration.total", "Configuration Partition Total Size (B)"],
    ["system.fs.log.available", "Log Partition Available Space (B)"],
    ["system.fs.log.total", "Log Partition Total Size (B)"],
    ["system.fs.root.available", "Root Partition Available Space (B)"],
    ["system.fs.root.total", "Root Partition Total Size (B)"],
    ["system.proc.loadavg", "System Load Average"],
    ["system.proc.meminfo.MemAvailable", "Memory Available"],
    ["system.proc.meminfo.MemTotal", "Memory Total"],
    ["system.sensors.cpu_temp", "CPU Temperature (°C)"],
    ["system.utime", "sphirewalld User Mode Time (jiffies)"],
  ];

  const get_SelectionMap = () => {
    const ret = [];
    // MemTotal and MemAvailable are reported in bytes starting in SphireOS 269
    // Also a couple new metrics were added
    const memoryUnits = sphireos_version < 269 ? " (KiB)" : " (B)";
    for (const metric of SPHIREOS_PERFORMANCE_METRICS) {
      if (sphireos_version < 269) {
        if (metric[0] === "system.sensors.cpu_temp" || metric[0] === "system.proc.loadavg") {
          continue;
        }
      }
      if (metric[0].includes("system.proc.meminfo")) {
        ret.push([metric[0], "[" + metric[0] + "]  " + metric[1] + memoryUnits]);
      } else {
        ret.push([metric[0], "[" + metric[0] + "]  " + metric[1]]);
      }
    }

    return ret;
  };

  return (
    <div className="main-content-sub-element">
      <div className="row">
        <div className="col-md-12">
          <div>
            <SearchableSelect value={dynamic_metric} onChange={handle_MetricChange} valueDataMap={get_SelectionMap()} clearable={false} />
            {is_parent ? (
              <div className="deviceSelector">
                <br />
                <Checkbox isChecked={selected_device_ids === device_ids} onChange={handle_SelectAll}>
                  Select All
                </Checkbox>
                <MultiSelect
                  showPills={false}
                  label=""
                  placeholder="Select device IDs"
                  selectedItems={selected_device_ids}
                  items={device_ids}
                  onChange={(newSelected) => {
                    handle_SetSelectedDevices(newSelected);
                  }}
                  canClearAll={true}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticsMetricsAdvancedSelector;
